import {schema as Schema} from 'normalizr';

export const integrationsListEntity = new Schema.Entity('items', {}, {idAttribute: 'id'});
export const integrationsListSchema = new Schema.Array(integrationsListEntity);

export const integrationStatusesEntity = new Schema.Entity('items', {}, {idAttribute: 'id'});
export const integrationStatusesSchema = new Schema.Array(integrationStatusesEntity);
